<template>
    <div>
        <div v-if=" question != '' " class="question-label">{{ question }}</div>
        <div class="sf2-switch" :class="[ active_switch == 1 ? 'first' : 'last' ]">
            <div class="colorize-bg" :data-cs-override-id="trackingid+'-'+option_a" v-html="option_a" @click="toggle()"></div>
            <div class="colorize-bg" :data-cs-override-id="trackingid+'-'+option_b" v-html="option_b" @click="toggle()"></div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "SwitchBox",
        props: {
            question: String,
            option_a: String,
            option_b: String
        },
        data() {
            return {
                active_switch: 1,
                selected: '',
                trackingid: 'switch'
            };
        },
        mounted() {
            console.log( 'SwitchBox mounted ' );
        },
        computed: {
                
        },
        methods: {
            
            toggle: function( ) {
                console.log( 'SwitchBox toggle' );

                if ( this.active_switch == 1 ){
                    this.active_switch = 2;
                    this.$emit( 'onChange', { 'val': this.option_b } );
                } else {
                    this.active_switch = 1;
                    this.$emit( 'onChange', { 'val': this.option_a } );
                }

                console.log( 'SwitchBox toggle current', this.active_switch );
            }
            
        },
    };

</script>

<style scoped>

</style>